import * as React from "react";
const SvgInvoiceOutlined = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "currentColor"}
      d="M6 22a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 3 19v-3h3V2l1.5 1.5L9 2l1.5 1.5L12 2l1.5 1.5L15 2l1.5 1.5L18 2l1.5 1.5L21 2v17q0 1.25-.875 2.125A2.9 2.9 0 0 1 18 22zm12-2q.424 0 .712-.288A.97.97 0 0 0 19 19V5H8v11h9v3q0 .424.288.712.287.288.712.288M9 9V7h6v2zm0 3v-2h6v2zm8-3a.97.97 0 0 1-.712-.287A.97.97 0 0 1 16 8q0-.424.288-.713A.97.97 0 0 1 17 7q.424 0 .712.287Q18 7.576 18 8q0 .424-.288.713A.97.97 0 0 1 17 9m0 3a.97.97 0 0 1-.712-.287A.97.97 0 0 1 16 11q0-.424.288-.713A.97.97 0 0 1 17 10q.424 0 .712.287.288.288.288.713 0 .424-.288.713A.97.97 0 0 1 17 12M6 20h9v-2H5v1q0 .424.287.712Q5.576 20 6 20"
    />
  </svg>
);
export default SvgInvoiceOutlined;
